import { TextInput, DateInput } from "react-admin";
import Grid from "@mui/material/Grid";
import NoArrowKeyNumberInput from "@/components/NoArrowKeyNumberInput";

import { ManualITSInput } from "./components/ManualItsInput";

const MuttavatteenYearlyFields = () => (
  <Grid container spacing={1}>
    <Grid size={{ xs: 12, lg: 6 }}>
      <ManualITSInput source="itsNo" label="ITS No." fullWidth required />
    </Grid>
    <Grid size={{ xs: 12, lg: 6 }}>
      <TextInput source="name" label="Full Name" fullWidth />
    </Grid>
    <Grid size={{ xs: 12, lg: 6 }}>
      <TextInput
        source="whatsappNo"
        label="WhatsApp"
        placeholder="+919876543210"
        fullWidth
        required
        helperText="E.164 format with '+' prefix (e.g. +919876543210)"
      />
    </Grid>
    <Grid size={{ xs: 12, lg: 6 }}>
      <TextInput source="address" label="Address" fullWidth />
    </Grid>
    <Grid size={{ xs: 12, lg: 6 }}>
      <TextInput source="pan" label="PAN" fullWidth />
    </Grid>
    <Grid size={{ xs: 12, lg: 6 }}>
      <NoArrowKeyNumberInput source="takhmeen" label="Yearly Takhmeen" fullWidth />
    </Grid>
    <Grid size={{ xs: 12, lg: 6 }}>
      <DateInput
        source="lastPaidDate"
        label="Last Paid Date"
        fullWidth
        helperText="Future dates allowed. If backdated and takhmeen exists, ledger entries will be created."
      />
    </Grid>
    <Grid size={{ xs: 12, lg: 6 }}>
      <TextInput source="remarks" label="Remarks" fullWidth />
    </Grid>
  </Grid>
);

export default MuttavatteenYearlyFields;
